import { create } from "zustand";

type UnleashContextState = {
  /**
   * True once the signed-in user's Unleash context update (userId + tenantId)
   * has settled — the proxy refetched with that context, or the update failed
   * and anonymous flag values are the best we will get. The client's own
   * `flagsReady` flips true after the initial anonymous fetch, before the
   * user context is applied, so it cannot be used alone to decide that
   * per-user flag values are final.
   */
  isUserContextSettled: boolean;
  setUserContextSettled: (isUserContextSettled: boolean) => void;
};

const useUnleashContextStore = create<UnleashContextState>((set) => ({
  isUserContextSettled: false,
  setUserContextSettled: (isUserContextSettled) =>
    set({ isUserContextSettled }),
}));

export default useUnleashContextStore;
